import React from 'react'
import { truncateToTwoDecimals } from '@/utils'

export const StaffUnitsCount = ({ t, totalStaffUnits, totalFreeStaffUnits }) => {
	return (
		<p>
			{t('count_staff_units_1')}
			<span>{truncateToTwoDecimals(totalStaffUnits)}</span>
			{t('count_staff_units_2')}
			<span>{truncateToTwoDecimals(totalFreeStaffUnits)}</span>
		</p>
	)
}
